import {
  getItemsForCategory,
  menuCategories,
  getLocalized,
} from "./menu";

/** Page-1 printed board slots (non-alcohol). */
export const drinksBoardSlots = [
  { id: "coffee", area: "kave", sketch: "cup", columns: 1 },
  { id: "matcha", area: "matcha", sketch: "leaves", columns: 1 },
  { id: "tea", area: "tea", sketch: "leaves", columns: 1 },
  { id: "iced", area: "iced", sketch: "ice", columns: 1 },
  { id: "soft", area: "soft", sketch: "bottle", columns: 2, leftCount: 5 },
  { id: "juice", area: "juice", sketch: "citrus", columns: 1 },
];

/** Page-2 alcohol board. */
export const alcoholBoardSlots = [
  { id: "beer", area: "beer", sketch: "none", columns: 1 },
  { id: "cocktails", area: "cocktails", sketch: "none", columns: 1 },
  { id: "spirits", area: "spirits", sketch: "none", columns: 1 },
  { id: "wine", area: "wine", sketch: "none", columns: 1 },
];

export function getDrinkPanel(slot, lang) {
  const category = menuCategories.find((c) => c.id === slot.id);
  if (!category) return null;
  const items = getItemsForCategory(slot.id);
  return {
    ...slot,
    category,
    title: getLocalized(category.label, lang),
    note: getLocalized(category.note, lang),
    items,
  };
}

export function getDrinksBoardPanels(lang) {
  return drinksBoardSlots
    .map((slot) => getDrinkPanel(slot, lang))
    .filter(Boolean);
}

export function getAlcoholBoardPanels(lang) {
  return alcoholBoardSlots
    .map((slot) => getDrinkPanel(slot, lang))
    .filter(Boolean);
}

/** Split items into columns like the print (soft drinks: 6 + rest). */
export function splitColumns(items, columns, leftCount) {
  if (columns < 2 || items.length === 0) return [items];
  const n = leftCount ?? Math.ceil(items.length / 2);
  return [items.slice(0, n), items.slice(n)];
}
